export default __webpack_public_path__ + "static/media/finance-guide-hire-purchase.900620a9.svg";